import SafetyDatabaseInspectionTypes from './safetyDatabaseInspection.types';
import { OBSERVATIONS_INITIAL_VALUES } from '../safetyInspection/safetyInspection.reducer';
import { RADIOS_INITIAL_VALUES } from '../../lib/buildInitialState';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment/moment';

export default (state = {}, { type, payload }) => {
	switch (type) {
		case SafetyDatabaseInspectionTypes.DB_HYDRATE_INSPECTION_FORM: {
			const date = Math.floor(Date.now() / 1000); // unix seconds timestamp

			return {
				...state,
				[payload.id]: {
					id: payload.id,
					date,
					title: `Unassigned_${moment(date * 1000).format('MM-DD-YY')}`,
					formData: cloneDeep(payload.submission)
				}
			};
		}
		case SafetyDatabaseInspectionTypes.DB_CLEAR_SAFETY_INSPECTION_FORMS:
			return {};
		case SafetyDatabaseInspectionTypes.DB_UPDATE_TITLE: {
			return {
				...state,
				[payload.id]: {
					...state[payload.id],
					title: `${payload.projectNumber ? payload.projectNumber : 'Unassigned'}_${payload.date}${
						payload.completedBy ? `_${payload.completedBy}` : ''
					}`
				}
			};
		}
		case SafetyDatabaseInspectionTypes.DB_UPDATE_INFO_FIELD: {
			return {
				...state,
				[payload.id]: {
					...state[payload.id],
					formData: {
						...state[payload.id].formData,
						info: {
							...state[payload.id].formData.info,
							[payload.key]: {
								...state[payload.id].formData.info[payload.key],
								value: payload.value
							}
						}
					}
				}
			};
		}
		case SafetyDatabaseInspectionTypes.DB_UPDATE_OBSERVATIONS_FIELDS: {
			return {
				...state,
				[payload.id]: {
					...state[payload.id],
					formData: {
						...state[payload.id].formData,
						observations: {
							...state[payload.id].formData.observations,
							[payload.section]: {
								...state[payload.id].formData.observations[payload.section],
								fields: {
									...state[payload.id].formData.observations[payload.section].fields,
									[payload.observation]: {
										...state[payload.id].formData.observations[payload.section].fields[
											payload.observation
										],
										...OBSERVATIONS_INITIAL_VALUES,
										[payload.key]: payload.value
									}
								}
							}
						}
					}
				}
			};
		}
		case SafetyDatabaseInspectionTypes.DB_UPDATE_UNSAFE_ACTS_PROCEDURE_DEVIATIONS_FIELD: {
			return {
				...state,
				[payload.id]: {
					...state[payload.id],
					formData: {
						...state[payload.id].formData,
						unsafe_acts_procedure_deviations: {
							...state[payload.id].formData.unsafe_acts_procedure_deviations,
							fields: {
								...state[payload.id].formData.unsafe_acts_procedure_deviations.fields,
								[payload.deviation]: {
									...state[payload.id].formData.unsafe_acts_procedure_deviations.fields[
										payload.deviation
									],
									...RADIOS_INITIAL_VALUES,
									[payload.key]: payload.value
								}
							}
						}
					}
				}
			};
		}
		case SafetyDatabaseInspectionTypes.DB_UPDATE_ADDITIONAL_ACT_PROCEDURE: {
			return {
				...state,
				[payload.id]: {
					...state[payload.id],
					formData: {
						...state[payload.id].formData,
						unsafe_acts_procedure_deviations: {
							...state[payload.id].formData.unsafe_acts_procedure_deviations,
							additional_act_procedure: state[
								payload.id
							].formData.unsafe_acts_procedure_deviations.additional_act_procedure.map((act, index) => {
								if (index === payload.index) {
									return {
										...act,
										...RADIOS_INITIAL_VALUES,
										[payload.key]: payload.value
									};
								}
								return act;
							})
						}
					}
				}
			};
		}
		case SafetyDatabaseInspectionTypes.DB_UPDATE_COMMENTS: {
			return {
				...state,
				[payload.id]: {
					...state[payload.id],
					formData: {
						...state[payload.id].formData,
						comments: payload.value
					}
				}
			};
		}
		case SafetyDatabaseInspectionTypes.DB_UPDATE_VIOLATIONS_FIELD: {
			return {
				...state,
				[payload.id]: {
					...state[payload.id],
					formData: {
						...state[payload.id].formData,
						violations: state[payload.id].formData.violations.map((violation, index) => {
							if (index === payload.index) {
								return {
									...violation,
									[payload.key]: payload.value
								};
							}
							return violation;
						})
					}
				}
			};
		}
		default:
			return state;
	}
};
